import React, { useContext } from 'react';

import { QPageLoader, useCurrentUser } from '@qualio/ui-components';

import { EditorMode } from '../../../util/EditModeUtils';
import { DocumentOverviewContext } from '../DocumentOverview/Context';
import { canUserEditDocument } from '../DocumentOverview/RenderLogic';
import { useTrainingAssessment } from './hooks/useTrainingAssessment';

import { EditTrainingAssessment } from './EditTrainingAssessment';
import { TrainingAssessment } from './TrainingAssessment';
import { TrainingAssessmentErrorState } from './TrainingAssessmentErrorState';

export const TrainingAssessmentContainer: React.FC = () => {
  const { qualioDocument, currentEditorMode } = useContext(
    DocumentOverviewContext,
  );
  const currentUser = useCurrentUser();
  const canUserEdit = canUserEditDocument(qualioDocument, currentUser);
  const isMultiRootEditorEnabled =
    qualioDocument?.editor_version?.startsWith('multiroot');

  const {
    data: trainingAssessment,
    isLoading,
    isError,
  } = useTrainingAssessment(qualioDocument.id);
  const isEditMode = isMultiRootEditorEnabled
    ? canUserEdit
    : currentEditorMode === EditorMode.EDIT;

  if (isError) {
    return <TrainingAssessmentErrorState />;
  }
  if (isLoading) {
    return <QPageLoader />;
  }

  if (isEditMode) {
    return (
      <EditTrainingAssessment
        trainingAssessment={trainingAssessment}
        documentId={qualioDocument.id}
      />
    );
  }

  return <TrainingAssessment questions={trainingAssessment?.questions} />;
};
